import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * Input i perbashket per forma me validim inline.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      "h-12 w-full rounded-md border border-input bg-background px-4 text-base text-foreground shadow-sm outline-none transition app-focus placeholder:text-muted-foreground",
      className,
    )}
    {...props}
  />
));

Input.displayName = "Input";
